module.exports = __webpack_public_path__ + "img/step_2.01ccf88c.png";